import React from "react";
import styled from "@emotion/styled";

interface SegPatenteProps {
  text: string;
  className?: string;
}

/** Azul de la banda Mercosur de la chapa argentina (mismo que SegPatenteInput). */
const AZUL_MERCOSUR = "#011590";
const INK = "#10151f";

/** Chapa patente read-only, en el mismo formato Mercosur del paso 1 (SegPatenteInput). */
const Chapa = styled.div`
  flex: none;
  width: 112px;
  background: #fff;
  border: 1.5px solid ${INK};
  border-radius: 6px;
  overflow: hidden;
  text-align: center;
`;

const Banda = styled.div`
  background: ${AZUL_MERCOSUR};
  color: #fff;
  font-size: 7px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  padding: 2px 0 1px;
  font-weight: 500;
`;

const Numero = styled.div`
  font-family: "DM Mono", "Cascadia Mono", ui-monospace, "SF Mono", Menlo,
    Consolas, monospace;
  font-size: 19px;
  letter-spacing: 0.06em;
  padding: 5px 0 6px;
  color: ${INK};
`;

export const SegPatente = ({ text = "", className }: SegPatenteProps) => (
  <Chapa className={className}>
    <Banda>Argentina</Banda>
    <Numero>{text}</Numero>
  </Chapa>
);
